import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const input_style = {
    backgroundColor: "blue",
  border: "1px solid white",
  color: "white",
  padding: "1px",
  margin: "2px",
  cursor: "pointer"
}

export const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ctpwp6n', 'template_mx395nc', form.current, 'TAAdzxTwHH8UrsimG')
      .then((result) => {
          console.log(result.text);
          alert("Nachricht gesendet.")
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <div className="container mt-5 text-light">
      <h1>Kontaktieren Sie mich</h1>
      <form className="row g-3" ref={form} onSubmit={sendEmail}>
      <div className="col-md-6">
        <label className='form-label'>Name</label>
        <input type="text" className='form-control' name="user_name" id="name" required/>
      </div>
      <div className="col-md-6" >
        <label className='form-label'>E-Mail</label>
        <input type="email" className='form-control' name="user_email" id="emailInfo" required />
      </div>
      <div className="col-md-12">
        <label className="form-label" >Nachricht</label>
        <textarea className="form-control" id="comments" rows="3" name="message" />
      </div>
      <div className="col-md-12">   
         <input style={input_style} class="btn btn-primary" type="submit" value="Send"/>
      </div>
    </form>
    </div>
  );
};